
import React, {
  useEffect,
  useState,
} from 'react';

import InvoiceFieldQuiz
  from '../quizTypes/InvoiceFieldQuiz.jsx';

import InvoiceIdentifyParties
  from '../quizTypes/InvoiceIdentifyParties.jsx';


const LeftLessonRenderer = ({
  content,
  step,
  invoice,
}) => {

  /*
    CONTROL AFISARE TEORIE / QUIZ
  */

  const [showQuiz, setShowQuiz] = useState(false);


  /*
    La schimbarea pasului,
    revenim automat la teorie.
  */

  useEffect(() => {
    setShowQuiz(false);
  }, [step?.id]);


  /*
    IDENTIFICARE ACTIVITATE
  */

  const right = step?.right || null;

  const quizTypes = [
    'invoiceFieldQuiz',
    'invoiceIdentifyParties',
  ];

  const activity =
    right?.quiz ||
    (quizTypes.includes(right?.type)
      ? right
      : null);


  /*
    RENDER QUIZ
  */

  const renderQuiz = () => {

    if (!activity) {
      return null;
    }

    switch (activity.type) {

      case 'invoiceFieldQuiz':
        return (
          <InvoiceFieldQuiz
            content={activity}
            invoice={invoice}
          />
        );

      case 'invoiceIdentifyParties':
        return (
          <InvoiceIdentifyParties
            content={activity}
            invoice={invoice}
          />
        );

      default:
        return null;
    }
  };


  const quizComponent = renderQuiz();


  if (!content) {
    return null;
  }


  /*
    AFISARE
  */

  return (
    <div className="conta-primara-left-renderer">

      {!showQuiz ? (

        /* ==========================
           ECRAN TEORIE
        ========================== */

        <>

          {content.eyebrow && (
            <span className="conta-primara-category">
              {content.eyebrow}
            </span>
          )}


          {content.title && (
            <h1>
              {content.title}
            </h1>
          )}


          {Array.isArray(content.content) &&
            content.content.map((item, index) => (
              <div
                key={index}
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              />
            ))
          }


          {content.highlight && (
            <div className="conta-primara-example">

              <span>
                {content.highlight.title}
              </span>

              <p>
                {content.highlight.text}
              </p>

            </div>
          )}


          {/* BUTON DESCHIDERE QUIZ */}

          {quizComponent && (
            <button
              type="button"
              className="conta-primara-start-quiz"
              onClick={() => setShowQuiz(true)}
            >
              Incepe quiz-ul
              <span> →</span>
            </button>
          )}

        </>

      ) : (

        /* ==========================
           ECRAN QUIZ
        ========================== */

        <>

          <button
            type="button"
            className="conta-primara-back-theory"
            onClick={() => setShowQuiz(false)}
          >
            ← Inapoi la teorie
          </button>


          <div
            className="conta-primara-left-quiz"
            key={step?.id}
          >
            {quizComponent}
          </div>

        </>

      )}

    </div>
  );
};


export default LeftLessonRenderer;
